// OfflineIndicator — tiny dot in the corner that lights up when offline.
// Listens to window 'online'/'offline'. Returns null when online so it
// doesn't take layout space.

import { useEffect, useState } from "react";
import { T } from "../tokens";

export interface OfflineIndicatorProps {
  /** "top-right" by default */
  corner?: "top-right" | "top-left";
}

export function OfflineIndicator({ corner = "top-right" }: OfflineIndicatorProps) {
  const [offline, setOffline] = useState(() =>
    typeof navigator !== "undefined" ? !navigator.onLine : false,
  );

  useEffect(() => {
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);

  if (!offline) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 6,
        [corner === "top-right" ? "right" : "left"]: 8,
        zIndex: 101,
        display: "flex",
        alignItems: "center",
        gap: 6,
        padding: "3px 8px",
        background: T.ink900,
        color: T.paper,
        fontFamily: T.mono,
        fontSize: 9,
        letterSpacing: "0.18em",
      }}
    >
      <span
        style={{
          display: "inline-block",
          width: 6,
          height: 6,
          background: T.paper,
          borderRadius: "50%",
        }}
      />
      OFFLINE
    </div>
  );
}
